import { connect } from 'react-redux';

import Main from './components/Main/Main';

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(Main);
